// extracted by mini-css-extract-plugin
export default {"message":"SubscriptionBanner_message__VUBtN","cta":"SubscriptionBanner_cta__2VDI8"};